import { ReactNode, MutableRefObject, useState, ChangeEvent } from "react";
import { FormControlProps } from "react-bootstrap/FormControl";
import classNames from "clsx";

import Form from "react-bootstrap/Form";

import { SkeletonWrapper } from "@/components/SkeletonWrapper";
import { MaskedFormControl } from "../MaskedFormControl";

import "./styles.scss";

export type Props = FormControlProps & {
	label?: ReactNode;
	inputRef?: MutableRefObject<any>;
	labelClassName?: string;
	isMaskedInput?: boolean;
	mask?: string;
	formattedFormControlClassName?: string;
	containerClassName?: string;
	skeleton?: boolean;
	skeletonWidth?: string | number;
	skeletonHeight?: string | number;
	displayCharactersRemaining?: boolean;
};

export function FormattedFormControl({
	id,
	label,
	inputRef,
	labelClassName,
	isMaskedInput = false,
	mask,
	formattedFormControlClassName,
	containerClassName,
	skeleton = false,
	skeletonWidth,
	skeletonHeight,
	onChange,
	displayCharactersRemaining = false,
	...rest
}: Props) {
	const maxLength = rest.maxLength || 0;
	const [charactersRemaining, setCharactersRemaining] = useState(maxLength);
	const needsCharactersRemaining = displayCharactersRemaining && maxLength;

	function handleWithCharactersRemaining(
		event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) {
		if (!needsCharactersRemaining) {
			return;
		}

		const length = event.target.value.length;

		setCharactersRemaining(maxLength - length);
	}

	const isNotTextarea = rest.as !== "textarea";
	const inputDefaultClassNames = isNotTextarea ? "h-38px" : "";

	return (
		<Form.Group controlId={id} className={containerClassName}>
			{label && (
				<>
					{skeleton ? (
						<SkeletonWrapper width={skeletonWidth} />
					) : (
						<Form.Label className={labelClassName}>{label}</Form.Label>
					)}
				</>
			)}

			{skeleton ? (
				<SkeletonWrapper width={skeletonWidth} height={skeletonHeight} />
			) : (
				<>
					{isMaskedInput ? (
						<MaskedFormControl
							className={classNames(
								inputDefaultClassNames,
								formattedFormControlClassName
							)}
							mask={mask}
							onChange={(
								event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
							) => {
								handleWithCharactersRemaining(event);
								onChange?.(event);
							}}
							{...(rest as any)}
						/>
					) : (
						<Form.Control
							className={classNames(
								inputDefaultClassNames,
								formattedFormControlClassName
							)}
							ref={inputRef}
							onChange={(event) => {
								handleWithCharactersRemaining(event);
								onChange?.(event);
							}}
							{...rest}
						/>
					)}

					{needsCharactersRemaining && (
						<p className="w-100 text-gray-700 mt-2">
							{charactersRemaining} caracteres restantes
						</p>
					)}
				</>
			)}
		</Form.Group>
	);
}
